(function () {
  const cookieName = 'includeVAT';

  function readMode() {
    const match = document.cookie.match(new RegExp('(?:^|; )' + cookieName + '=([^;]*)'));
    return !match || decodeURIComponent(match[1]) !== 'false' ? 'inc' : 'ex';
  }

  function persistMode(mode) {
    const maxAge = 60 * 60 * 24 * 30;
    document.cookie = `${cookieName}=${mode === 'inc'}; path=/; max-age=${maxAge}; SameSite=Lax`;
  }

  function syncControls(mode) {
    document.querySelectorAll('[data-vat-toggle]').forEach((input) => {
      input.checked = mode === 'inc';
      input.setAttribute('aria-checked', String(mode === 'inc'));
    });
    document.querySelectorAll('[data-vat-toggle-text]').forEach((label) => {
      label.textContent = mode === 'inc' ? 'Inc. VAT' : 'Exc. VAT';
    });
  }

  function setMode(mode, persist) {
    document.documentElement.dataset.vatMode = mode;
    syncControls(mode);
    if (persist) persistMode(mode);
    document.dispatchEvent(new CustomEvent('mh:vat-change', { detail: { mode } }));
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-vat-toggle]')) return;
    setMode(event.target.checked ? 'inc' : 'ex', true);
  });

  document.addEventListener('DOMContentLoaded', () => setMode(readMode(), false));
  document.addEventListener('shopify:section:load', () => syncControls(readMode()));
})();
